import { render, staticRenderFns } from "./ComponentEdit.vue?vue&type=template&id=3a1a6df0"
import script from "./ComponentEdit.vue?vue&type=script&lang=js"
export * from "./ComponentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports